import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/app.service';


@Component({
  selector: 'app-view-user-referral',
  templateUrl: './view-user-referral.component.html',
  styleUrls: ['./view-user-referral.component.scss']
})
export class ViewUserReferralComponent implements OnInit {

  @Output() closeActivityAtDialog: EventEmitter<any> = new EventEmitter();

  windowRef: any;
  userDetails: any;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ViewUserReferralComponent>,
    public as: AppService,
    public appService: AppService,
    public routes: ActivatedRoute,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.userDetails = this.data['user'];
    this.windowRef = this.as.windowRef;
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close();
    this.closeActivityAtDialog.emit(null);
  }

}
